// GENERATED FILE - DO NOT MODIFY
import { ServiceCallOccupationCategoryModel } from "api/models/company/service-call/service-call-occupation-category-model";
import { PagingInfo } from "api/paging-info";
import BaseProxy from "api/proxies/base-proxy";
import ModelDateTransformer from "api/util/model-date-transformer";
import { autoinject } from "aurelia-framework";
import { ApiHelper } from "helpers/api-helper";
import { HttpClientFactory } from "http-client/http-client-factory";
import { HttpClientRequestConfig } from "http-client/http-client-request-config";

@autoinject()
export class ServiceCallOccupationCategoryProxy extends BaseProxy {
    constructor(modelDateTransformer: ModelDateTransformer, httpClientFactory: HttpClientFactory, apiHelper: ApiHelper) {
        super(modelDateTransformer, httpClientFactory, apiHelper);
    }

    public async GetServiceCallOccupationCategories(dispatchTemplateId: string | null | undefined, filter?: string, pagingInfo?: PagingInfo, requestConfig?: HttpClientRequestConfig): Promise<ServiceCallOccupationCategoryModel[] | null> {
        const uri = this.buildUri(
            "/service-call/occupation-category",
            null,
            { dispatchTemplateId: (dispatchTemplateId === null || dispatchTemplateId === undefined) ? undefined : dispatchTemplateId, filter: filter ? filter : undefined, page: (pagingInfo && pagingInfo.page ? pagingInfo.page.toString() : undefined), pagesize: (pagingInfo && pagingInfo.pageSize ? pagingInfo.pageSize.toString() : undefined) }
        );

        const data: ServiceCallOccupationCategoryModel[] | null = await this.get<ServiceCallOccupationCategoryModel[] | null>(uri, requestConfig);
        this.transformModels(data, "Company.ServiceCall.ServiceCallOccupationCategoryModel");
        return data;
    }

    public async GetServiceCallOccupationCategory(occupationCategoryId: number, requestConfig?: HttpClientRequestConfig): Promise<ServiceCallOccupationCategoryModel | null> {
        const uri = this.buildUri(
            "/service-call/occupation-category/{occupationCategoryId}",
            { occupationCategoryId: (occupationCategoryId === null || occupationCategoryId === undefined) ? undefined : occupationCategoryId.toString() },
            null
        );

        const data: ServiceCallOccupationCategoryModel | null = await this.get<ServiceCallOccupationCategoryModel | null>(uri, requestConfig);
        this.transformModels(data, "Company.ServiceCall.ServiceCallOccupationCategoryModel");
        return data;
    }
}
